import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import {DomSanitizer} from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-changes',
  templateUrl: './changes.component.html',
  styleUrls: ['./changes.component.scss']
})
export class ChangesComponent implements OnInit {

  changesList: any;

  constructor(
    private _appService: AppService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.spinner.show();

    this._appService.getAllAppChanges().subscribe(data => {
      this.changesList = data;
      this.spinner.hide();
    });
  }

}
